import { GKButton, GKModal, Grid2, SendIcon, Typography } from "components";

interface SendLinkModalProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  onSend: () => void;
  email: string;
  stageName: string;
}

const SendLinkModal = ({
  open,
  setOpen,
  onSend,
  email,
  stageName,
}: SendLinkModalProps) => {
  return (
    <GKModal
      width={"505px"}
      modalTitle="Send Link"
      open={open}
      setOpen={setOpen}
      footer={
        <GKButton startIcon={<SendIcon />} variant="contained" onClick={onSend}>
          Send Link
        </GKButton>
      }
    >
      <Grid2 container>
        <Grid2 size={12}>
          <Typography fontSize={12} fontWeight={500} color="var(--neutral-500)">
            {"You're about to send the "}
            <span style={{ fontWeight: 600 }}>{stageName}</span>
            {
              " link to the user. Make sure the user's contact information is up to date before proceeding."
            }
          </Typography>
        </Grid2>
        <Grid2
          container
          alignItems="center"
          justifyContent="flex-start"
          size={12}
          gap={1}
          mt={2}
        >
          <Typography fontSize={12} fontWeight={500} color="var(--neutral-500)">
            Recipient&apos;s Email ID:
          </Typography>
          <Typography fontSize={12} fontWeight={500} color="var(--neutral-700)">
            {email || "-"}
          </Typography>
        </Grid2>
      </Grid2>
    </GKModal>
  );
};

export default SendLinkModal;
